import { useState } from "react";
import { API_URL } from "src/util/config";
import { checkResponse } from "src/util/helpers";
import { useAuth } from "src/contexts/AuthContext";

interface CreateRunResult {
  acquisitionId: string;
  runId: string;
  stageCode: string;
  status: string;
}

export const useCreateAcquisitionRun = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const { fetchWithReauth } = useAuth();

  const createRun = async (
    acquisitionId: string,
    params: {
      stageCode: string;
      spreadsheetUrl: string;
      fin8SpreadsheetUrl?: string;
      fin28SpreadsheetUrl?: string;
      fin27SpreadsheetUrl?: string;
      classFullname?: string;
      departmentFullname?: string;
      invoiceForm?: string;
      subscriptionPlanId?: string;
      productName?: string;
      jiraTicket?: string;
      comment?: string;
    }
  ): Promise<CreateRunResult | null> => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetchWithReauth(
        `${API_URL}/acquisition-imports/${acquisitionId}/runs`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(params),
        }
      );
      return (await checkResponse(response)) as CreateRunResult;
    } catch (err) {
      const message =
        err instanceof Error ? err.message : "Failed to queue stage run.";
      setError(message);
      console.error("Error creating acquisition run:", err);
      return null;
    } finally {
      setLoading(false);
    }
  };

  return { createRun, loading, error, setError };
};
